import React from 'react';
import { useState, } from "react";
import { useNavigate, Link } from "react-router-dom";

import logoNovo from '../../assets/images/logoNovo.png';
import { SweetAlertSuccess, SweetAlertError } from '../../components/sweetAlert/swetAlert.jsx';
import apiAdm from '../../services/apiAdm';

function EsqueciSenha() {

    const [email, setEmail] = useState('');

    const navigate = useNavigate();


    return <>
        <div className="main-wrapper">
            <div className="page-wrapper full-page">
                <div className="page-content d-flex align-items-center justify-content-center">
                    <div className="card">
                        <div className="row">
                            <div className="col-md-12 ps-md-1">
                                <div className="auth-form-wrapper px-6 py-5">
                                    <div className="row">
                                        <span className="img-container">
                                            <img src={logoNovo} style={{ marginLeft: 130 }} width={150} height={45} />
                                        </span>
                                    </div>
                                    <br /><br></br>
                                    <div className="row">
                                        <a href="#" className="noble-ui-logo d-block mb-2">Recuperar senha</a>
                                        <form className="forms-sample">
                                            <div className="mb-3">
                                                <label for="userEmail" className="form-label">Informe seu e-mail</label>
                                                <input type="text" className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} />
                                            </div>
                                            <br />
                                            <div>
                                                <button onClick={enviar} className="btn btn-primary w-100 text-white" type="button">Enviar</button>
                                            </div>
                                            <Link to="/login" className="nav-link d-block mt-3 text-center text-muted">Voltar</Link>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>;

    function enviar() {

        if (email == '') {
            SweetAlertError({ texto: 'Falta informar o e-mail.' });
            return;
        };
        const json = {
            email: email,
        };

        apiAdm.post('/usuario/recuperarsenha', json)
            .then((resp) => {
                console.log(resp);
                SweetAlertSuccess({texto: 'E-mail enviado com sucesso.'});
                navigate("/login");
            })
            .catch((erro) => {
                console.log(erro);
                SweetAlertError({ texto: 'Falha ao enviar seu e-mail.' });
                return;
            });

    };


};

export default EsqueciSenha;
